import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ppt-vertical',
  standalone: false,
  templateUrl: './ppt-vertical.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class PptVerticalComponent {
  @Input() pptTest:any
}
